<template>
  <div>
    <vue-headful title="Profiel Weergave" />
    <Header page_title="Profiel Weergave" />
    <div v-if="userCandidate" id="profile" class="profile-layout app-body">
      <div class="profile-notifications">
        <div class="container-fluid">
          <div v-if="userCandidate.is_interested == 1" class="sd-notif success mb-2"><svg-icon icon="thumbs_up" />Je hebt interesse getoond in deze persoon!</div>
          <div v-if="userCandidate.is_interview_invited == 1" class="sd-notif success mb-2"><svg-icon icon="thumbs_up" />Je hebt deze persoon uitgenodigd voor een kennismaking!</div>
          <div v-if="userCandidate.is_declined == 1" class="sd-notif danger mb-2"><svg-icon icon="trash" />Je hebt deze persoon afgewezen</div>
        </div>
      </div>
      <div class="profile-intro">
        <div class="container-fluid">
          <h1 class="sd-title bold small pb-4">Hi, ik ben {{ userCandidate.firstname }}</h1>
          <div class="profile-specs">
            <div class="avatar rounded-circle position-relative overflow-hidden">
              <span v-if="userCandidate.avatar" class="d-block image_background" :style="this.ImageBackground(userCandidate.avatar)"></span>
              <svg-icon v-else icon="person_male" />
            </div>
            <div class="profile-specs-info">
              <template v-if="subBranch === '1'">
                <div class="salary" v-if="userCandidate.cost_per_hour"><svg-icon icon="suitcase"></svg-icon>&euro; {{ userCandidate.cost_per_hour.replace(/\./g, ",") }} per uur</div>
                <div class="salary" v-else><svg-icon icon="suitcase"></svg-icon>Deze kandidaat heeft nog geen uurloon ingevuld.</div>
              </template>
<!--              <div v-else class="salary"><svg-icon icon="suitcase"></svg-icon>&euro; {{ parseFloat(userCandidate.salary_per_hour).toFixed(2) }} per uur</div>-->
              <div class="location"><svg-icon icon="marker"></svg-icon>{{ userCandidate.city ? userCandidate.city : "" }}</div>
              <template v-if="subBranch === '1'">
                <div class="customer-type"><svg-icon icon="file_contract"></svg-icon>{{ userCandidate.customer_type === 0 ? "Uitzendkracht" : "ZZP'er" }}</div>
              </template>
            </div>
          </div>

          <div v-if="userCandidate.achievements.length > 0" class="achievements_container">
            <achievements :achievements="userCandidate.achievements"></achievements>
          </div>
        </div>
      </div>
      <svg-icon icon="wave" class="seperator" />
      <div class="profile-messages bg-gray" v-if="userCandidate.interested_comment || userCandidate.comment || userCandidate.hired_comment">
        <div class="container-fluid no-grid">
          <div class="sd-title mini mb-20px">
            <div class="title-text"><svg-icon icon="blackboard" /> Berichten</div>
          </div>
        </div>
        <div class="container-fluid pt-1 px-0">
          <div class="message interested" v-if="userCandidate.interested_comment">
            <div class="sd-title mini">{{ userCompany.name }}</div>
            <div class="sd-notif warning interested">
              <div class="small text-left br">{{ userCandidate.interested_comment }}</div>
            </div>
          </div>
          <div class="message apply" v-if="userCandidate.comment">
            <div class="sd-title mini text-align-right">{{ userCandidate.firstname }}</div>
            <div class="sd-notif warning apply" >
              <div class="small text-left br">{{ userCandidate.comment }}</div>
            </div>
          </div>
          <div class="alert alert-warning hired" v-if="userCandidate.hired_comment">
            <div class="small text-left br">{{ userCandidate.hired_comment }}</div>
          </div>
        </div>
      </div>
      <div class="job-notification-banner bg-gray" v-if="userCompany.type == 2">
        <div class="container-fluid">
          <template v-if="companyContact && companyContact.phone">
            <NotificationBanner notification="warning">
              <b>Even overleggen over deze kandidaat?</b>
              <ul>
                <li>Bel ons op: <a  :href="`tel:+${companyContact.phone}`">{{companyContact.number}}</a></li>
                <li>Contact ons via <a class="" :href="`https://api.whatsapp.com/send?phone=${companyContact.phone}&text=${encodeURIComponent(this.whatsappMessage)}`">Whatsapp</a></li>
                <li>Stuur ons een <router-link
                    :to="{ name: 'contact' }"
                >berichtje</router-link
                ></li>
              </ul>
            </NotificationBanner>
          </template>
          <template v-else>
            <NotificationBanner notification="warning">
              <b>Even overleggen over deze kandidaat?</b>
              <ul>
                <li>Bel ons op: <a href="tel:+31850481976">085 048 1976</a></li>
                <li>Contact ons via <a class="" :href="`https://api.whatsapp.com/send?phone=31850481976&text=${encodeURIComponent(this.whatsappMessage)}`">Whatsapp</a></li>
                <li>Stuur ons een <router-link
                    :to="{ name: 'contact' }"
                >berichtje</router-link
                ></li>
              </ul>
            </NotificationBanner>
          </template>
        </div>
      </div>
      <div class="profile-calendar bg-gray">
        <div id="calendar" class="pb-4">
          <div class="container-fluid">
            <h2 class="title-with-icon sd-title text-yellow mini mb-4"><svg-icon icon="blackboard" />Vacature</h2>
            <div class="sd-container small-radius bg-white text">
              <div class="availablity-specs">
                <template v-if="userCandidate.city_location">
                  <strong>Locatie</strong>
                  <span v-if="userCandidate.name_location">{{ userCandidate.name_location }} ({{ userCandidate.city_location }})</span>
                  <span v-else>{{ userCandidate.company_name }} ({{ userCandidate.city_location }})</span>
                </template>
                <template v-if="subBranch == '1'"><strong>Groep</strong> <span>groep {{ formattedAudience() }}</span></template>
                <template v-if="subBranch == '2'"><strong>Vak en klas(sen)</strong> <span>{{ userCandidate.subject }} - {{ formattedAudience() }} klas</span></template>
                <template v-if="userCandidate.group"><strong>Onderwijsniveau</strong> <span>{{ formattedGroup() }}</span></template>
                <strong>Start-/einddatum</strong> <span>{{ dateFlip(firstDate()) }}{{ totalDates > 1 ? ("/" + dateFlip(lastDate())) : "" }}</span>
                <template v-if="subBranch != '2' && this.userCandidate.duration_type != 1">
                  <strong>Totaal aantal dagen</strong> <span>{{totalDates}} {{totalDates > 1 ? "dagen" : "dag"}}</span>
                </template>
                <template v-if="subBranch != '2' && this.userCandidate.duration_type != 1">
                  <strong>Dagen beschikbaar</strong> <span>{{ this.totalMatchedDays }}</span>
                </template>
                <strong v-if="subBranch == '2' && this.userCandidate.periods">Aantal lesuur per week</strong> <span v-if="this.userCandidate.periods && subBranch == '2'">{{ this.userCandidate.periods }} lesuur (+ opslagfactor)</span>
                <strong v-if="subBranch == '2' && this.workingDatesWithTimes || this.userCandidate.duration_type == 1 && subBranch == '1' && this.workingDates">Dagen</strong> <span
                  v-if="this.workingDatesWithTimes && subBranch == '2' || this.userCandidate.duration_type == 1 && subBranch == '1' && this.workingDates">{{ getWorkingDays() }}</span>
              </div>
            </div>
            <div class="position-relative calendar-container bg-white">
              <div class="click-container" @click="fakeCalendar">
                <div class="calendar-title">
                  <strong>Bekijk alle beschikbare dagen</strong>
                </div>
                <div class="calendar-icon">
                  <div class="icon-wrapper">
                    <svg-icon icon="calendar" />
                  </div>
                </div>
              </div>
              <transition
                  @enter="enter"
                  @leave="leave"
                  name="expand"
              >
                  <div
                      v-show="show_calendar"
                      class="syncfusion-calendar position-relative availability"
                  >
                    <div class="icon-wrapper arrow-back">
                      <i class="material-icons-round">arrow_back</i>
                    </div>
                    <div class="icon-wrapper arrow-forward">
                      <i class="material-icons-round">arrow_forward</i>
                    </div>
                    <v-calendar
                        locale="nl"
                        :first-day-of-week="week"
                        :min-date="minDate"
                        :max-date="maxDate"
                        :attributes="highlight"
                        :disabled-dates="disableDates"
                        ref="calendarInstance"
                        is-expanded
                        is-inline
                    />
                  </div>
                </transition>
              </div>
            <div class="sd-container small-radius bg-white text" v-if="userCompany.sub_branch != 2 && this.userCandidate.duration_type != 1">
              <job-dates-overview v-if="userCompany.sub_branch == 1" :all-dates="workingDates" :unmatched-reasons="unmatched_reasons" :subBranch="subBranch"></job-dates-overview>
<!--              <job-dates-overview v-if="userCompany.sub_branch == 2"  :all-dates="workingDatesWithTimes" :unmatched-reasons="unmatched_reasons" :subBranch="subBranch"></job-dates-overview>-->
            </div>
          </div>
        </div>

        <div class="profile-experience">
          <div class="container-fluid">
            <div class="position-relative">
              <h2  class="title-with-icon sd-title text-yellow mini mb-4"><svg-icon icon="suitcase" />Profielschets</h2>
              <div class="sd-container small-radius bg-white text position-relative">
                <div class="details position-relative">
                  <p class="mb-2">
                    <span class="d-inline-block position-relative" v-if="this.userCandidate.derect_about_candidate" v-html="this.userCandidate.derect_about_candidate"></span>
                    <span v-else>
                      Derect heeft een (digitale) kennismaking met iedere kandidaat. Hier vind je onze profielschets zodra die gereed is.
                    </span>
                  </p>
                </div>
              </div>
              <h2 class="title-with-icon sd-title text-yellow mini mb-4"><svg-icon icon="diploma" />Ervaring</h2>
              <div v-if="this.userCandidate.sub_branch == '1,2'" class="tab-item-container">
                <div class="tab-item" @click="activeTab='po'" :class="activeTab === 'po'?'active':''">Basisonderwijs</div>
                <div class="tab-item" @click="activeTab='vo'" :class="activeTab === 'vo'?'active':''">Voortgezet onderwijs</div>
              </div>
              <div v-if="subBranch_1 && activeTab === 'po'" class="sd-container small-radius bg-white text tab-container">
                <div v-if="subBranch_1.experience.years_experience >= 0" class="years-experience text-center mb-4">
                  <strong>{{ subBranch_1.experience.years_experience+" jaar ervaring" }}</strong>
                </div>
                <div class="position-relative">
                  <label><b>Relevante functies</b></label>
                  <div class="details position-relative">
                    <p class="mb-2 add-comma">
                      {{ !subBranch_1.experience.position ? "-" : "" }}
                      <span
                        v-for="(item, i) in subBranch_1.experience.position"
                        v-bind:key="i"
                        class="d-inline-block position-relative"
                      >{{ item }}</span>
                    </p>
                  </div>
                </div>
                <div>
                  <label class="text text-yellow">Doelgroepen</label>
                  <div class="position-relative mb-3">
                    <div class="details position-relative">
                      <p class="mb-2 add-comma">
                        {{ !subBranch_1.experience.audience ? "-" : "" }}
                        <span
                          v-for="(item, i) in subBranch_1.experience.audience"
                          v-bind:key="i"
                          class="d-inline-block position-relative"
                        >{{ item }}</span>
                      </p>
                    </div>
                  </div>
                  <label class="text text-yellow">Type onderwijs</label>
                  <div class="position-relative mb-3">
                    <div class="details position-relative">
                      <p class="mb-2 add-comma">
                        {{ !subBranch_1.experience.education_experience ? "-" : "" }}
                        <span
                          v-for="(item, i) in subBranch_1.experience.education_experience"
                          v-bind:key="i"
                          class="d-inline-block position-relative"
                        >{{ item }}</span>
                      </p>
                    </div>
                  </div>
                  <label class="text text-yellow">Denominaties</label>
                  <div class="position-relative mb-3">
                    <div class="details position-relative">
                      <p class="mb-2 add-comma">
                        {{ !subBranch_1.experience.denomination ? "-" : "" }}
                        <span
                          v-for="(item, i) in subBranch_1.experience.denomination"
                          v-bind:key="i"
                          class="d-inline-block position-relative"
                        >{{ item }}</span>
                      </p>
                    </div>
                  </div>
                  <label class="text text-yellow">Opleidingen</label>
                  <div class="position-relative mb-3">
                    <div class="position-relative">
                      <p v-if="this.subBranch_1.diplomaArray" class="education">
                          <span
                            v-for="(item, i) in this.subBranch_1.diplomaArray"
                            v-bind:key="i"
                            class="position-relative"
                          >{{ item }}</span>
                      </p>
                      <p v-else>
                        <span class="d-block position-relative">Niet ingevuld</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="subBranch_2 && activeTab === 'vo'" class="sd-container small-radius bg-white text tab-container">
                <div v-if="subBranch_2.experience.years_experience > 0" class="years-experience text-center mb-4">
                  <strong>{{ subBranch_2.experience.years_experience+" jaar ervaring" }}</strong>
                </div>
                <label class="text text-yellow">Relevante functies</label>
                <div class="position-relative mb-3">
                  <div class="details position-relative">
                    <p class="mb-2">
                      <span class="add-comma">
                        {{ !subBranch_2.experience.position ? "-" : "" }}
                        <span
                          v-for="(item, i) in subBranch_2.experience.position"
                          v-bind:key="i"
                          class="d-inline-block position-relative"
                        >{{ item }}</span>
                      </span>
                    </p>
                  </div>
                </div>
                <label class="text text-yellow">Doelgroepen</label>
                <div class="position-relative mb-3">
                  <div class="details position-relative">
                    <p class="mb-2">
                      <span class="add-comma">
                        {{ !subBranch_2.experience.group_experience ? "-" : "" }}
                        <span
                          v-for="(item, i) in subBranch_2.experience.group_experience"
                          v-bind:key="i"
                          class="d-inline-block position-relative"
                        >{{ item }}</span>
                      </span>
                    </p>
                  </div>
                </div>
                <label class="text text-yellow">Onderwijsniveau</label>
                <div class="position-relative mb-3">
                  <div class="details position-relative">
                    <p class="mb-2">
                      <span class="add-comma">
                        {{ !subBranch_2.experience.education_experience ? "-" : "" }}
                        <span
                          v-for="(item, i) in subBranch_2.experience.education_experience"
                          v-bind:key="i"
                          class="d-inline-block position-relative"
                        >{{ item }}</span>
                      </span>
                    </p>
                  </div>
                </div>
                <label class="text text-yellow">Bijzondere onderwijsvormen</label>
                <div class="position-relative mb-3">
                  <div class="details position-relative">
                    <p class="mb-2">
                      <span class="add-comma">
                        {{ !subBranch_2.experience.special_education_experience ? "-" : "" }}
                        <span
                          v-for="(item, i) in subBranch_2.experience.special_education_experience"
                          v-bind:key="i"
                          class="d-inline-block position-relative"
                        >{{ item }}</span>
                      </span>
                    </p>
                  </div>
                </div>
                <label class="text text-yellow">Vakken</label>
                <template v-for="subjects in subBranch_2.experience.subject">
                  <div v-for="(items, subject) in subjects" class="details position-relative mb-1">
                    <label class="text text-yellow d-block mb-0">{{ subject }}</label>
                    <span v-for="(qualification, type) in items" class="d-block">
                      <template v-if="qualification != false">
                        <span v-if="type === 'studying'">Studerend</span>
                        <span v-if="type === 'qualified'">Bevoegd</span>
                        <span v-if="type === 'experienced'">Ervaring met</span>
                        <span v-if="type === 'can_also_give'">Kan ook geven</span>
                        <span v-if="qualification === 'Beide'">: 1e en 2e graads</span>
                        <span v-else>: {{ qualification }}</span>
                      </template>
                    </span>
                  </div>
                </template>
                <template v-if="userCandidate.sub_branch === '2' || userCandidate.sub_branch === '1,2'">
                  <br/>
                  <label v-if="subBranch_1.education['1'] === 'YES'" class="text text-yellow">{{ userCandidate.firstname }} heeft (ook) een pabo diploma</label>
                </template>
              </div>
            </div>
            <template v-if="subBranch != '2'">
              <h2 class="title-with-icon sd-title text-yellow mini mb-4"><svg-icon icon="heart" />Match</h2>
              <div class="sd-container small-radius bg-white text pie-container" >
                <div class="pie_content text-left">
                  <p>{{ userCandidate.percentage }}% match</p>
                  <template v-if="Object.keys(unmatched_reasons).length > 0">
                    <strong v-if="Object.keys(unmatched_reasons).length == 1">Het volgende punt matcht niet:</strong>
                    <strong v-else>De volgende punten matchen niet:</strong>
                    <ul>
                      <li v-for="(item, i) in unmatched_reasons" v-bind:key="i" class="alert_feeds">
                        <span v-if="i === 'dates'">Sommige gevraagde datums matchen niet de beschikbaarheid van deze kandidaat</span>
                        <span v-else>{{ item }}</span>
                      </li>
                    </ul>
                  </template>
                  <template v-else>
                    <strong>Dit is een perfecte match voor deze functie!</strong>
                  </template>
                </div>
                <div class="alert_pie" :class="Object.keys(unmatched_reasons).length > 0 ? '' : 'full-marks'">
                  <span>{{ userCandidate.percentage }}%</span>
                  <svg-icon v-if="Object.keys(unmatched_reasons).length > 0" icon="pie_chart_75" />
                  <svg-icon v-else icon="pie_chart_100" />
                </div>
              </div>
            </template>
          </div>
        </div>

        <div class="profile-buttons bg-gray pb-4">
          <div class="container-fluid">
            <button
              v-if="interestedNotif && userCandidate.is_interested !== 1"
              type="button"
              v-on:click.stop="onInterestedNotification()"
              class="btn btn-warning btn-block"
            >Interesse tonen</button>
<!--            <button-->
<!--              v-if="!hired && hiredNotif && !userCandidate.is_declined && !userCandidate.is_declined && subBranch !== '2'"-->
<!--              v-on:click.stop="onAccept()"-->
<!--              type="button"-->
<!--              class="btn btn-warning btn-block"-->
<!--              v-ripple="'rgba(255, 255, 255, 0.35)'"-->
<!--            >Sollicitatie accepteren</button>-->
            <button
              v-if="!hired && hiredNotif && !userCandidate.is_declined && !userCandidate.is_declined && subBranch !== '2' && userCandidate.duration_type == 0"
              v-on:click.stop="onAccept()"
              type="button"
              class="btn btn-warning btn-block"
              v-ripple="'rgba(255, 255, 255, 0.35)'"
            >Sollicitatie accepteren</button>
            <button
                v-if="!hired && hiredNotif && !userCandidate.is_declined && userCandidate.is_interview_invited != 1 && (subBranch == '2' || subBranch == '1' && userCandidate.duration_type == 1)"
                v-on:click.stop="onInvitation()"
                type="button"
                class="btn btn-warning btn-block"
                v-ripple="'rgba(255, 255, 255, 0.35)'"
            >Plan een kennismaking</button>
            <button
                v-if="!hired && hiredNotif && !userCandidate.is_declined"
                v-on:click.stop="onDecline()"
                type="button"
                class="btn btn-danger btn-block"
                v-ripple="'rgba(255, 255, 255, 0.35)'"
            >Sollicitatie afwijzen</button>
            <button
              v-if="hired && !show_info"
              v-on:click="show_info = true"
              type="button"
              class="btn btn-warning btn-block"
              v-ripple="'rgba(255, 255, 255, 0.35)'"
            >Contact Info</button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="fullscreen_notif == 'comment'" class="fullscreen-notif match position-fixed">
      <button
        type="button"
        class="close position-fixed"
        aria-label="Close"
        v-on:click="fullscreen_notif = null; job_applicant_id = null; comment = ''"
      >
        <div class="icon-wrapper">
          <i class="material-icons-round">close</i>
        </div>
      </button>
      <div class="d-flex min-height align-items-center">
        <div class="container-fluid px-4 mx-2">
          <div class="text-center pb-1">
            <div>
              <NotificationContainer />
              <div class="form-group text-left">
                <h4>Heb je nog vragen of opmerkingen voor {{ userCandidate.firstname }}?</h4>
              </div>
              <div class="form-group mb-4">
                <textarea
                  maxlength="160"
                  class="form-control"
                  :placeholder="'Laat hier een bericht achter voor de kandidaat. Bijvoorbeeld: overleg van de dagen, vaardigheden, de periode, enz. \n(max 160 karakters)'"
                  rows="4"
                  spellcheck="false"
                  v-model="comment"
                ></textarea>
                <span class="extra-info text-left mt-2">
                  <svg-icon icon="information" />
                  Laat hier een bericht achter voor de kandidaat. Bijvoorbeeld: overleg van de dagen, vaardigheden, de periode, enz. (max 160 karakters)
                </span>
              </div>
              <a v-if="interestedNotif && !hiredNotif" class="btn btn-warning btn-block" role="button" @click="onInterested">Doorgaan</a>
              <a v-if="!interestedNotif && hiredNotif" class="btn btn-warning btn-block" role="button" @click="onSubmitAccept">Doorgaan</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="fullscreen_notif == 'decline'" class="fullscreen-notif match position-fixed">
      <button
          type="button"
          class="close position-fixed"
          aria-label="Close"
          v-on:click="fullscreen_notif = null; job_applicant_id = null; comment = ''"
      >
        <div class="icon-wrapper">
          <i class="material-icons-round">close</i>
        </div>
      </button>
      <div class="d-flex min-height align-items-center">
        <div class="container-fluid px-4 mx-2">
          <div class="text-center pb-1">
            <div>
              <NotificationContainer />
              <template v-if="subBranch != '2'">
                <div class="sd-title mini mb-20px">
                  <div class="title-text"><svg-icon icon="heart" /> Match</div>
                </div>
                <div class="sd-container small-radius bg-white text pie-container" v-if="Object.keys(unmatched_reasons).length > 0">
                  <div class="pie_content text-left">
                    <ul><li class="sd-title mini">Er is een {{ userCandidate.percentage }}% match</li></ul>
                    <strong>De volgende punten matchen niet:</strong>
                    <ul>
                      <li v-for="(item, i) in unmatched_reasons" v-bind:key="i" class="alert_feeds">
                        <span v-if="i === 'dates'">sommige gevraagde datums matchen niet de beschikbaarheid van deze kandidaat</span>
                        <span v-else>{{ item }}</span>
                      </li>
                    </ul>
                  </div>
                  <div class="alert_pie">
                    <span>{{ userCandidate.percentage }}%</span>
                    <svg-icon icon="pie_chart_75" />
                  </div>
                </div>
              </template>
              <div class="text-left">
                <h4>Weet je zeker dat je de sollicitatie van {{ userCandidate.firstname }} wilt afwijzen?</h4>
                <h5>De sollicitant ontvangt hier een automatisch bericht van.</h5>
              </div>
              <a class="btn btn-warning btn-block" role="button" @click="onSubmitDecline">Doorgaan</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="fullscreen_notif == 'invitation'" class="fullscreen-notif match position-fixed">
      <button
          type="button"
          class="close position-fixed"
          aria-label="Close"
          v-on:click="fullscreen_notif = null; job_applicant_id = null; comment = ''"
      >
        <div class="icon-wrapper">
          <i class="material-icons-round">close</i>
        </div>
      </button>
      <div class="d-flex min-height align-items-center">
        <div class="container-fluid px-4 mx-2">
          <div class="text-center pb-1">
            <div>
              <NotificationContainer />

              <div class="form-group text-left">
                <h5>Heb je specifieke vragen voor/over deze kandidaat of opmerkingen m.b.t. de vacature?</h5>
              </div>
              <div></div>
              <div class="form-group mb-4">
                <textarea
                    maxlength="160"
                    class="form-control"
                    :placeholder="'Laat hier een bericht achter voor Derect. \n(max 160 karakters)'"
                    rows="4"
                    spellcheck="false"
                    v-model="comment"
                ></textarea>
              </div>
              <div class="form-group mb-4">
                <div class="form-group text-left">
                  <h5>Op welke dagen/momenten kan het kennismakingsgesprek plaatsvinden?</h5>
                </div>
                <textarea
                    maxlength="160"
                    class="form-control"
                    :placeholder="'Laat hier een bericht achter voor Derect. \n(max 160 karakters)'"
                    rows="4"
                    spellcheck="false"
                    v-model="schedule"
                ></textarea>
              </div>
<!--              <a v-if="interestedNotif && !hiredNotif" class="btn btn-warning btn-block" role="button" @click="onInterested">Doorgaan</a>-->
              <a v-if="!interestedNotif && hiredNotif" class="btn btn-warning btn-block" role="button" @click="onSubmitInvitation">Verstuur aan Derect</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Hired
      v-model="show_info"
      v-if="hired && show_info"
      :user="hired"
      :show="true"
      :create_new="create_new"
    />
    <Footer />
  </div>
</template>

<script>
import Achievements from "@/components/Achievements";
import JobDatesOverview from "@/components/JobDatesOverview";

export default {
  data: function() {
    return {
      activeTab: 'po',
      diplomas: '',
      branch: localStorage.getItem("branch"),
      subBranch: localStorage.getItem("subBranch"),
      userCandidate: null,
      userCompany: null,
      companyContact: null,
      hired: null,
      show_info: false,
      whatsappMessage: "",
      profession: "",
      subBranch_1: {
        diplomaArray: false,
      },
      subBranch_2: {
        diplomaArray: false,
      },
      workfield_as_text: "",
      guide: {
        1: [
          { url: 1, label: "Opgeleid als leerkracht" },
          { url: "1_YES", label: null },
          { url: "1_STUDYING_A", label: null },
          { url: "1_STUDYING_B", label: null }
        ],
        2: [
          { url: 2, label: "Onderwijsassistent" },
          { url: "2_YES", label: null },
          { url: "2_YES_EXTRA", label: "Zelfstandig voor de klas" },
          { url: "2_STUDYING_A", label: null },
          { url: "2_STUDYING_B", label: null }
        ],
        3: [
          { url: 3, label: "1e of 2e graad" },
          { url: "3_YES", label: null },
          { url: "3_STUDYING_A", label: null },
          { url: "3_STUDYING_B", label: null }
        ],
        4: [
          { url: 4, label: "Master EN (SEN)" },
          { url: "4_YES", label: null },
          { url: "4_STUDYING_A", label: null },
          { url: "4_STUDYING_B", label: null }
        ],
        5: [
          { url: 5, label: "Buitenlandse lesbevoegdheid" },
          { url: "5_YES", label: null }
        ]
      },
      reviews: null,
      show_calendar: false,
      dates: [],
      minDate: "",
      maxDate: "",
      week: 2,
      highlight: [],
      fullscreen_notif: null,
      interestedNotif: this.$route.name === 'view-match',
      hiredNotif: this.$route.name === 'view-applicant',
      comment: "",
      schedule: "",
      unmatched_reasons: {},
      create_new: false,
      workingDates: null,
      workingDatesWithTimes: null,
      availableWorkingDates: [],
      totalDates: null,
      hiddenDates: null,
      showAllDates: false,
      totalMatchedDays: null
    };
  },
  props: ["id"],
  computed: {
    // a computed getter
  },
  async created() {},
  async mounted() {
    await this.fetchData();
    this.calculateDates();
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    async fetchData() {
      this.$store.state.loading = true;

      var minDate = new Date();
      minDate.setHours(0, 0, 0, 0);
      minDate.setDate(minDate.getDate() + 1);
      this.minDate = minDate;

      var maxDate = new Date();
      maxDate.setMonth(maxDate.getMonth() + 3);
      maxDate.setHours(0, 0, 0, 0);
      this.maxDate = maxDate;

      this.userCompany = JSON.parse(localStorage.getItem("user"));

      if(this.userCompany.company_contact)
      {
        this.companyContact = await this.getTokenAPIList(
            "admins/" + parseInt(this.userCompany.company_contact)
        );

        if(this.companyContact.number) {
          let original_number = this.companyContact.number;

        this.companyContact.phone = original_number.replace(/^\d/, "31");
        }
      }

      if(this.$route.name == 'view-match') //Als school een aanbeveling bekijkt
      {
        this.userCandidate = await this.getTokenAPIList("matched/" + parseInt(this.id));
        if(this.userCandidate && this.userCandidate.working_dates)
        {
          this.workingDates = JSON.parse(this.userCandidate.working_dates);

          if(this.userCompany.sub_branch == '2') {
            console.log(this.userCandidate.working_dates_with_times);
            this.workingDatesWithTimes = JSON.parse(JSON.parse(this.userCandidate.working_dates_with_times));
          } else {
            this.workingDatesWithTimes = [];
          }
        }
        else
          this.workingDates = '-'
      }
      else if(this.$route.name == 'view-applicant') //Als school een sollicitant bekijkt
      {
        this.userCandidate = await this.getTokenAPIList("applicant/" + parseInt(this.id));
        this.workingDates = JSON.parse(JSON.parse(this.userCandidate.working_dates));

        if(this.userCompany.sub_branch == '2')
          this.workingDatesWithTimes = JSON.parse(JSON.parse(this.userCandidate.working_dates_with_times));
      }
      else if(this.$route.name == 'applicant-profile')  //Als een kandidaat zichzelf bekijkt TODO: samenvoegen met applicant/profile
      {}

      if(this.userCandidate && this.userCandidate.unmatched_reasons)
      {
        this.unmatched_reasons = JSON.parse(this.userCandidate.unmatched_reasons);
        for (var key in this.unmatched_reasons) {
          if (key === "dates")
            this.create_new = true;
        }
      }

      if(this.userCompany.sub_branch == '2')
        this.activeTab = 'vo';

      if(this.userCandidate)
      {
        if(this.userCandidate.subBranch_1)
        {
          this.subBranch_1 = JSON.parse(this.userCandidate.subBranch_1);

          if(this.subBranch_1.education !== null)
            this.subBranch_1.diplomaArray = this.printDiplomas(this.subBranch_1);
        }

        if(this.userCandidate.subBranch_2)
        {

          this.subBranch_2 = JSON.parse(this.userCandidate.subBranch_2);

          if(this.userCandidate.subBranch_2.education !== null)
            this.subBranch_2.diplomaArray = this.printDiplomas(this.subBranch_2);
        }
        if(this.userCandidate.time_add_on)
          this.userCandidate.time_add_on = parseFloat(this.userCandidate.time_add_on);
      }

      this.whatsappMessage = "Ik heb een vraag over de kandidaat: " +
          this.userCandidate.firstname +
          ". Bij vacature: " +
          (this.userCandidate.title || this.userCandidate.job_title) +
          " (vacaturenummer: " + this.userCandidate.job_id + ").";

      this.loadDates();
      this.$forceUpdate();
      this.$store.state.loading = false;
    },
    enter(el) {
      el.style.maxHeight = "0";
      el.style.opacity = "0";
      el.style.overflow = "hidden";
      requestAnimationFrame(() => {
        el.style.transition = "max-height 0.3s ease, opacity 0.3s ease";
        el.style.maxHeight = el.scrollHeight + "px";
        el.style.opacity = "1";
      });
    },
    leave(el) {
      el.style.maxHeight = el.scrollHeight + "px";
      el.style.opacity = "1";
      el.style.overflow = "hidden";
      requestAnimationFrame(() => {
        el.style.transition = "max-height 0.3s ease, opacity 0.3s ease";
        el.style.maxHeight = "0";
        el.style.opacity = "0";
      });
    },
    scrollToReviews() {
      var element = document.getElementById("reviews");
      var top = element.offsetTop;
      // window.scrollTo(0, top);
      window.scrollTo({
        top: top,
        behavior: "smooth"
      });
    },
    async loadDates() {
      if (this.userCandidate.search_availability) {
        var array = [];
        var dates = JSON.parse(this.userCandidate.search_availability);
        for (var key in dates) {
          // let _date = new Date(dates[key] + " 10:00:00"); //wrong format
          let _date = dates[key];
          _date = _date.split('-');
          let _y = parseInt(_date[0]);
          let _m = parseInt(_date[1]) - 1;
          let _d = parseInt(_date[2]);

          _date = new Date(_y, _m, _d, 0, 0, 0);

          array.push(_date);
          this.dates.push(dates[key]);

        }

        if (array.length) {
          this.highlight = [{
            highlight: true,
            dates: array
          }];
        }
      }
    },
    disableDates: function(args) {
      // { weekdays: [1, 7] }
      var ymd = args.id;
      if (this.dates.indexOf(ymd) > -1) {
        args.classes.push('highlight');
      }
      args.isDisabled = true;
      return args;
    },
    fakeCalendar() {
      this.show_calendar = this.show_calendar ? false : true;
      let div = document.getElementsByClassName('calendar-container');
      div[0].classList.toggle('slide-fade');
    },
    async onInterestedNotification() {
      this.fullscreen_notif = "comment";
    },
    async onInterested() {
      return new Promise((resolve, reject) => {
        this.$store.state.loading = true;

        var url = this.$apiURI + "/interest";
        let user_token = JSON.parse(localStorage.getItem("user-token"));
        let formData = new FormData();
        formData.append("match_id", parseInt(this.userCandidate.match_id));
        formData.append("comment", this.comment);
        this.$http
          .post(url, formData, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(() => {
            this.$store.state.loading = false;
            this.userCandidate.is_interested = 1;
            this.comment = "";
            this.fullscreen_notif = null;
            if (typeof dataLayer !== "undefined") {
              dataLayer.push({
                event: "SchoolTeacherInterest",
                eventCategory: "School",
                eventAction: "School – Teacher interest",
                eventLabel: "",
                eventValue: "1"
              });
            }
            resolve();
          })
          .catch(error => {
            this.$store.state.loading = false;
            this.comment = "";
            this.fullscreen_notif = null;
            reject();
          });
      });
    },
    async onAccept() {
      this.fullscreen_notif = "comment";
    },
    async onInvitation() {
      this.fullscreen_notif = "invitation";
    },
    async onDecline() {
      this.fullscreen_notif = "decline";
    },

    async onSubmitAccept() {
      this.$store.state.loading = true;
      this.acceptApplicant(parseInt(this.id), this.comment)
        .then(() => {
          this.fullscreen_notif = null;
          let temp = {};
          temp["avatar"] = this.userCandidate.avatar;
          temp["firstname"] = this.userCandidate.firstname;
          temp["name"] = this.userCandidate.firstname;
          temp["mobile"] = this.userCandidate.mobile;
          temp["email"] = this.userCandidate.email;
          this.hired = temp;
          this.show_info = true;
        })
        .catch(() => {
          this.fullscreen_notif = "comment";
        });
    },
    async onSubmitInvitation() {
      this.$store.state.loading = true;
      this.sendInvitation(parseInt(this.id), this.comment, this.schedule)
          .then(() => {
            this.fullscreen_notif = null;
            this.$router.push('/company/applicants')
          })
          .catch(() => {
            this.fullscreen_notif = "comment";
          });
    },
    async onSubmitDecline() {
      this.$store.state.loading = true;
      this.declineApplicant(parseInt(this.id))
          .then(() => {
            this.fullscreen_notif = null;
            this.$router.push('/company/applicants')
          })
          .catch(() => {
            this.fullscreen_notif = "decline";
          });
    },
    translate(answer) {
      if (answer == "NO") {
        return "Nee";
      }
      if (answer == "YES") {
        return "Ja";
      }
      if (answer == "STUDYING") {
        return "Studerend";
      }
      return answer;
    },
    elContains(str, target) {
      return str.includes(target);
    },
    printDiplomas(currentBranch) {
      var diplomas = [];

      if(currentBranch.education["1_YES"]) {
        diplomas.push("Pabo (diploma, " + currentBranch.education["1_YES"] + ")");
      }
      if (currentBranch.education["1_STUDYING_A"]) {
        diplomas.push("Pabo " + "(" + currentBranch.education["1_STUDYING_A"] + ", " + currentBranch.education["1_STUDYING_B"] + ")");
      }
      if (currentBranch.education["2_YES"]) {
        diplomas.push("Onderwijsassistent (diploma, " + currentBranch.education["2_YES"] + ")");
      }
      if (currentBranch.education["2_STUDYING_A"]) {
        diplomas.push("Onderwijsassistent " + "(" + currentBranch.education["2_STUDYING_A"] + ", " + currentBranch.education["2_STUDYING_B"] + ")");
      }
      if (currentBranch.education["3_YES"]) {
        diplomas.push("Eerste- of tweedegraads docent (diploma, " + currentBranch.education["3_YES"] + ")");
      }
      if (currentBranch.education["3_STUDYING_A"]) {
        diplomas.push("Eerste- of tweedegraads docent " + "(" + currentBranch.education["3_STUDYING_A"] + ", " + currentBranch.education["3_STUDYING_B"] + ")");
      }
      if (currentBranch.education["4_YES"]) {
        diplomas.push("Master (SEN) (diploma, " + currentBranch.education["4_YES"] + ")");
      }
      if (currentBranch.education["4"] == "STUDYING") {
        diplomas.push("Master (SEN) (Studerend)");
      }
      if (currentBranch.education["5_YES"]) {
        diplomas.push("Buitenlandse bevoegheid (diploma, " + currentBranch.education["5_YES"] + ")");
      }
      if (currentBranch.education["5"] == "STUDYING") {
        diplomas.push("Buitenlandse bevoegheid (Studerend)");
      }

      if (diplomas.length >= 1) {
        return diplomas;
      } else {
        return false;
      }
    },
    calculateDates() {
      var _dates = this.dates;
      var _availableWorkingDates = [];

      Object.keys(this.workingDates).forEach(function(date) {
        if(_dates.includes(date))
          _availableWorkingDates.push(date);
      });

      this.availableWorkingDates = _availableWorkingDates;

      this.totalMatchedDays = this.availableWorkingDates.length;
      this.totalDates = Object.keys(this.workingDates).length;
    },
    dateFlip(date) {
      if(date)
        return date.split("-").reverse().join("-");
    },
    firstDate() {
      return this.availableWorkingDates[0];
    },
    lastDate() {
      let lastIndex = this.availableWorkingDates.length - 1;
      return this.availableWorkingDates[lastIndex];
    },
    formattedAudience() {
      try {
        return JSON.parse(this.userCandidate.audience).join(', ');
      } catch(error) {
        console.log('job.audience is not JSON');
        return this.userCandidate.audience;
      }
    },
    formattedGroup() {
      try {
        return JSON.parse(this.userCandidate.group).join(', ');
      } catch(error) {
        console.log('job.group is not JSON');
        return this.userCandidate.group;
      }
    },
    getWorkingDays() {
      if (this.userCompany.sub_branch == '1' && this.userCandidate.duration_type == 1) {
        if (this.userCandidate.dates_pending) return 'In overleg / nog onbekend';
        const days = new Set();
        const weekDays = ['Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag'];

        Object.keys(this.workingDates).forEach(date => {
          const dayIndex = new Date(date).getDay() - 1;
          if (dayIndex >= 0 && dayIndex < 5) {
            days.add(weekDays[dayIndex]);
          }
        });

        return weekDays.filter(day => days.has(day)).join(', ');
      } else {
        if (!this.workingDatesWithTimes) return '';
        if (this.userCandidate.dates_pending) return 'In overleg / nog onbekend';

        const days = new Set();
        const weekDays = ['Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag'];

        Object.keys(this.workingDatesWithTimes).forEach(date => {
          const dayIndex = new Date(date).getDay() - 1;
          if (dayIndex >= 0 && dayIndex < 5) {
            days.add(weekDays[dayIndex]);
          }
        });

        return Array.from(days).join(', ');
      }
    }
  },
  ready() {
    this.$forceUpdate();
  },
  components: {
    Achievements,
    JobDatesOverview
  }
};
</script>

<style scoped>
.profile-layout {
  margin-top: 40px;
}

/deep/.profile-layout .profile-intro .profile-specs .avatar .svg-container {
  padding: 15px;
}

/deep/.profile-layout .profile-intro .profile-specs .avatar .svg-container,
/deep/.profile-layout .profile-intro .profile-specs .avatar .svg-container svg {
  height: 100%;
  width: 100%;
}

.profile-layout .job-notification-banner {
  padding-top: 25px;
}

.profile-layout .profile-messages {
  padding-top: 20px;
  padding-bottom: 20px;
}

.profile-layout .profile-messages .container-fluid:not(.no-grid) {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.profile-layout .profile-messages .container-fluid .message .sd-title {
  margin-left: 15px;
}

.profile-layout .profile-messages .container-fluid .message.interested {
  grid-row: 1;
  grid-column: 1;
}

.profile-layout .profile-messages .container-fluid .message.apply {
  grid-row: 2;
  grid-column: 2;
}

.profile-layout .profile-calendar .availablity-specs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 15px;
  background-color: #FFF;
  font-size: 12px;
  line-height: 1;
}

.profile-layout .profile-calendar .calendar-container {
  border-radius: 10px;
  padding: 15px 30px;
  margin-bottom: 20px;
}

.profile-layout .profile-calendar .calendar-container .click-container {
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.profile-layout .profile-calendar .calendar-container .syncfusion-calendar {
  top: 5px;
  left: 0;
  z-index: 1;
}

.profile-layout .profile-calendar .sd-container {
  padding-bottom: 15px;
}

#profile .avatar {
  border-width: 4px;
}
.text {
  font-size: 14px;
  line-height: 22px;
}

.education span {
  display: block;
}

.btn-sm {
  background-color: #FFCD00;
  font: 13px/35px "Real Head Pro";
  font-weight: normal;
  color: #625a55;
  height: 35px;
  padding: 0 15px;
  border-radius: 4px;
}
.seperator {
  display: block;
  width: 100%;
  color: #F6F6F6;
}

.fullscreen-notif .avatar {
  width: 200px;
  height: 200px;
  border: 7.2pt solid white !important;
}

.fullscreen-notif p {
  font-size: 20px;
  line-height: 120%;
  white-space: pre-wrap;
  word-break: break-word;
}

.fullscreen-notif .text-left p {
  font-size: 15px;
  line-height: 100%;
  font-variant-numeric: lining-nums;
  font-family: "Real Head Pro";
  font-weight: 200;
}

header.overflow-hidden + div:not(.min-height)#profile {
  /* padding-bottom: 210px; */
  padding-bottom: 80px;
}

.add-comma span:not(:last-child):after {
  content: ",";
  margin-right: 3px;
}
#profile .info-group > div > div:not(:first-child) .details:before {
  display: none;
}

#profile #calendar .clearfix {
  height: auto;
}

.profile-layout .tab-container {
  border-radius: 0 30px 30px 30px
}

.profile-layout .tab-item-container {
  display: flex;
}

.profile-layout .tab-item-container .tab-item {
  border: 1px solid #64513D;
  border-bottom: 0;
  padding: 5px 15px;
  border-radius: 10px 10px 0 0;
  font-weight: bold;
  cursor: pointer;
}

.profile-layout .tab-item-container .tab-item.active {
  background-color: #FFF;
  border-color: #FFF;
}

.profile-layout .tab-item-container .tab-item:not(:last-child) {
  margin-right: 10px;
}

.achievements_container {
  position: relative;
  z-index: 5;
  display: inline-block;
}
/deep/ .achievements_container .achievement {
  margin-top: 30px;
}
.title-with-icon {
  display: flex;
  align-items: center;
}
/deep/ .title-with-icon .svg-container {
  display: flex;
  align-items: center;
}
/deep/ .title-with-icon svg {
  color: #ffcd00;
  margin-right: 15px;
  width: 15px;
}
.pie-container {
  display: flex;
  align-items: center;
}

.pie-container ul {
  list-style: none;
  padding-left: 0;
}

.pie-container ul li {
  display: flex;
  align-items: center;
  position: relative;
  padding-left: 20px;
}

.pie-container ul li::before {
  content: '';
  display: block;
  position: absolute;
  left: 0;
  height: 5px;
  width: 5px;
  border-radius: 100%;
  background-color: #FFCD00;
}

.alert_pie {
  position: relative;
}
.alert_pie span {
  font-size: 14px;
  position: absolute;
  color: #fff;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
}

.alert_pie.full-marks {
  display: flex;
  align-items: center;
  justify-content: center;
}

.alert_pie.full-marks span {
  bottom: unset;
  left: unset;
  transform: unset;
}

/deep/.pie-container svg {
  width: 60px;
}
/deep/.pie-container svg .filled-chart {
  fill: #ffcd00;
}
/deep/.pie-container svg .empty-chart {
  fill: #fff;
}

.expand-enter-active,
.expand-leave-active {
  transition: all 0.3s ease-in-out;
  overflow: hidden;
  max-height: 600px; /* adjust depending on expected calendar height */
  opacity: 1;
}

.expand-enter-from,
.expand-leave-to {
  max-height: 0;
  opacity: 0;
}
</style>
